import request from "@/util/request";

export default {
  districtWater: (data) => request({
    url: "/water-quality-web/screen/districtWater",
    method: "post",
    data
  }),
  queryEventBy30Day: (data) => request({
    url: "/water-quality-web/screen/queryEventBy30Day",
    method: "post",
    data
  }),
  queryInspectionTaskBy30Day: (data) => request({
    url: "/water-quality-web/screen/queryInspectionTaskBy30Day",
    method: "post",
    data
  }),
  riverWaterAnalyse: (data) => request({
    url: "/water-quality-web/screen/riverWaterAnalyse",
    method: "post",
    data
  }),
  riverWaterEvaluation: (data) => request({
    url: "/water-quality-web/screen/riverWaterEvaluation",
    method: "post",
    data
  }),
  riverWaterIndicator: (data) => request({
    url: "/water-quality-web/screen/riverWaterIndicator",
    method: "post",
    data
  }),
  riverWaterStatistics: (data) => request({
    url: "/water-quality-web/screen/riverWaterStatistics",
    method: "post",
    data
  }),
  screenStationData: (data) => request({
    url: "/water-quality-web/screen/screenStationData",
    method: "post",
    data
  }),
  screenTraceSourceStationData: (data) => request({
    url: "/water-quality-web/screen/screenTraceSourceStationData",
    method: "post",
    data
  }),
  stationDetailDItems: (data) => request({
    url: "/water-quality-web/screen/stationDetailDItems",
    method: "post",
    data
  }),
  stationDetailDItemTimingDiagrams: (data) => request({
    url: "/water-quality-web/screen/stationDetailDItemTimingDiagrams",
    method: "post",
    data
  }),
  stationDetailInspection: (data) => request({
    url: "/water-quality-web/screen/stationDetailInspection",
    method: "get",
    params: data
  }),
  waterPollutionTraceSource: (data) => request({
    url: "/water-quality-web/screen/waterPollutionTraceSource",
    method: "post",
    data
  }),
  queryWarningInfoBy30Day: (data) => request({
    url: "/api/Home/GetAlarmSummary",
    method: "get",
    data
  }),
  stationWaterAnalyse: (data) => request({
    url: "/water-quality-web/screen/stationWaterAnalyse",
    method: "post",
    data
  }),
  hydrologyStationDetail: (data) => request({
    url: "/water-quality-web/screen/hydrologyStationDetail",
    method: "post",
    data
  }),
  traceSourceStationDetailWarning: (data) => request({
    url: "/water-quality-web/screen/traceSourceStationDetailWarning",
    method: "get",
    params: data
  }),
  traceSourceStationData: (data) => request({
    url: "/water-quality-web/screen/traceSourceStationData",
    method: "post",
    data
  }),
  queryStationItems: (data) => request({
    url: "/water-quality-web/screen/queryStationItems",
    method: "post",
    data
  }),
  pollutionDetailWarning: (data) => request({
    url: "/water-quality-web/screen/pollutionDetailWarning",
    method: "post",
    data
  }),
  pollutingEnterprisesStationEnumList: (data) => request({
    url: "/water-quality-web/screen/pollutingEnterprisesStationEnumList",
    method: "get",
    params: data
  }),
  pollutingEnterprisesDetailItems: (data) => request({
    url: "/water-quality-web/screen/pollutingEnterprisesDetailItems",
    method: "post",
    data
  }),
  riverWaterComplianceTrend: (data) => request({
    url: "/water-quality-web/screen/riverWaterComplianceTrend",
    method: "post",
    data
  }),  
  riverWaterCategoryMonthStat: (data) => request({
    url: "/water-quality-web/screen/riverWaterCategoryMonthStat",
    method: "post",
    data
  }),
  riverWaterComplianceCalendar: (data) => request({
    url: "/water-quality-web/screen/riverWaterComplianceCalendar",
    method: "post",
    data
  }),
  queryCameraStatistics: (data) => request({
    url: "/water-quality-web/screen/queryCameraStatistics",
    method: "post",
    data
  }),
  queryUserOperationLog: (data) => request({
    url: "/water-quality-web/screen/queryUserOperationLog",
    method: "post",
    data
  }),
  districtEvaluationAdd: (data) => request({
    url: "/water-quality-web/districtEvaluation/add",
    method: "post",
    data
  }),
}



// WEBPACK FOOTER //
// ./src/api/screen.js